// Aufnahmen abspielen (Runde 7, Agent 7B): Typen und Client nach crm/API.md, Abschnitt 22.2. Die Komponente
// `components/AufnahmePlayer.tsx` benutzt diesen Client; 7B (Lead-Seite) und 7D (Gespräche, Anrufliste) setzen sie ein.
import { http } from "./client";

export type AufnahmeArt = "aufnahme" | "voicemail";

export interface AufnahmeInfo {
  verfuegbar: boolean;
  quelle: "close" | "twilio" | null;
  art: AufnahmeArt;
  dauer_s: number | null;
  /** Close löscht Aufnahmen nach 7 Tagen */
  laeuft_ab_am: string | null;
  mime: string | null;
  /** Warum nicht verfügbar (abgelaufen, nie aufgenommen, keine Berechtigung …) */
  grund?: string | null;
}

/** Adresse der Audiodatei (Server-Proxy, Range-fähig); direkt als `src` eines `<audio>` benutzbar. `herunterladen` liefert sie als Datei. */
export const aufnahmeUrl = (callId: string, art: AufnahmeArt = "aufnahme", herunterladen = false) => {
  const teile = [art === "voicemail" ? "art=voicemail" : "", herunterladen ? "herunterladen=true" : ""].filter(Boolean);
  return `/api/aufnahmen/${encodeURIComponent(callId)}${teile.length ? `?${teile.join("&")}` : ""}`;
};

export const aufnahmenApi = {
  info: (callId: string, art: AufnahmeArt = "aufnahme") => http.get<AufnahmeInfo>(`/api/aufnahmen/${encodeURIComponent(callId)}/info`, { art }),
};
